import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { DialogRef } from '@components/dialog/dialog-ref';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DeliveryOrder } from '@core/models/delivery/delivery-order';
import { ToastService } from '@core/state/toast/toast.service';
import { DeliveriesService } from '@features/deliveries/deliveries.service';
import { UpdateDeliveryOrderRequest } from '@core/models/delivery/update-delivery-order.request';
import { ApiErrorResponse } from '@core/data/api/error-response';

@Component({
    selector: 'ihd-dialog-update-address',
    templateUrl: 'dialog-update-address.component.html',
    styleUrls: ['./dialog-update-address.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'c-dialog-update-address',
    },
})
export class DialogUpdateAddressComponent implements OnInit {
    public config;
    public order: DeliveryOrder;
    public serviceProviderLabel: string;
    public isBusy: boolean = false;

    public submitted: boolean = false;

    public addressForm: FormGroup;

    constructor(
        public dialogRef: DialogRef<DialogUpdateAddressComponent>,
        private ordersService: DeliveriesService,
        private toastService: ToastService,
        private cdr: ChangeDetectorRef
    ) {
        this.addressForm = new FormGroup({
            address: new FormControl(null, Validators.required),
        });
        if (dialogRef.containerInstance && dialogRef.containerInstance.config) {
            this.config = dialogRef.containerInstance.config;
            this.order = this.config.order;
        }
    }

    ngOnInit() {}

    updateAddress() {
        this.submitted = true;
        this.cdr.markForCheck();

        if (this.addressForm.valid) {
            this.isBusy = true;
            this.cdr.markForCheck();

            const formValue = this.addressForm.value;
            const request = new UpdateDeliveryOrderRequest();
            request.dropoffAddress = formValue?.address?.address;
            this.ordersService.updateDeliveryOrder(this.order.id, request).subscribe(
                () => {
                    this.toastService.showSuccess('Order.Address.Update.Success');
                    this.close(true);
                },
                (error: { payload: ApiErrorResponse }) => {
                    this.toastService.showApiError(error);
                    this.isBusy = false;
                    this.cdr.markForCheck();
                }
            );
        } else {
            this.toastService.showWarning('Errors.FormInvalid');
        }
    }

    close(updated?: boolean) {
        this.dialogRef.close(updated);
    }
}
